import { ConditionalDataConfig } from '../../models/configuration/ConditionalDataConfig';
import { ConditionalHelper } from '@kurtosys/ksys-app-template/dist/helpers';

export default function getConditionalDataFlag(
    valuesForValidation: {},
    config: ConditionalDataConfig
) {
    if (config && config.conditional) {
        const conditionalHelper = new ConditionalHelper(config.conditional);
        return conditionalHelper.matches(valuesForValidation);
    }
    return false;
}



// WEBPACK FOOTER //
// ./src/utils/query/getConditionalDataFlag.ts